import { Col, Form, Modal, Row, Segmented, TextInput } from 'ui';

export type EventInviteesFiltersFormValues = {
  search?: string;
  type: EventInviteesFiltersType;
};

export type EventInviteesFiltersType = 'community' | 'individual';

type P = {
  hasDistributionList: boolean;
  type: EventInviteesFiltersType;
};

const EventInviteesFilters = ({ hasDistributionList, type }: P) => (
  <Modal.ScrollableContent.Header>
    <Row gutter="ms">
      {hasDistributionList ? (
        <Col span={8}>
          <Form.Item<EventInviteesFiltersFormValues> label="People" name="type" noOptional>
            <Segmented<EventInviteesFiltersType>
              options={[
                { label: 'Individual', value: 'individual' },
                { label: 'Community', value: 'community' },
              ]}
              size="large"
            />
          </Form.Item>
        </Col>
      ) : null}
      {type === 'community' ? null : (
        <Col span={hasDistributionList ? 16 : 24}>
          <TextInput
            hasSearch
            item={{
              label: 'Search',
              name: 'search',
              noOptional: true,
            }}
          />
        </Col>
      )}
    </Row>
  </Modal.ScrollableContent.Header>
);

export default EventInviteesFilters;
